import { render, staticRenderFns } from "./ChannelTypeStatistics.vue?vue&type=template&id=4902220e&"
import script from "./ChannelTypeStatistics.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypeStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelTypeStatistics.vue"
export default component.exports